import { Box } from "@mui/material";
import RelationshipTypeForm from "./form";
import { HRService } from "../../../../config";
import { RelationshipTypesColumns } from "../../../../data/Columns/hrmanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { allRelationshipTypes } from "../../../../data/Queries/HRmanagement/leavemanagement";

const base_url = HRService.uri;

const actions = {
  entity: "Relationship Type",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  markTask: {
    key: "MARK_TASK_DONE",
    button_name: "Mark Task Done",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  showStatus: true,
};

function RelationshipTypeTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Relationship Types"
        subtitle="View all relationship types, create and edit"
        columns={RelationshipTypesColumns}
        FormComponent={RelationshipTypeForm}
        actions={actions}
        query={allRelationshipTypes}
        base_url={base_url}
      />
    </Box>
  );
}

export default RelationshipTypeTable;